import {newAxios} from './index'

export const Req_GetDepartmentList = function (data) {
  return newAxios({
    url: `/i/tenant/system/dept/list`,
    data
  })()
}

export const Req_UpdateDepartment = function (data) {
  return newAxios({
    url: `/i/tenant/system/dept/update`,
    data
  },'json')()
}

export const Req_CreateDepartment = function (data) {
  return newAxios({
    url: `/i/tenant/system/dept/add`,
    data
  },'json')()
}

export const Req_DeleteDepartment = function (data) {
  return newAxios({
    url: `/i/tenant/system/dept/delete/${data.id}`
  })()
}

export const Req_InviteTeamer = function (data) {
  return newAxios({
    url: `/i/tenant/user/invite/colleagues`,
    data: {list:data}
  },'json')()
} 

export const Req_GetTeamerList = function (data) {
  return newAxios({
    url: `/i/tenant/user/group/all`,
    data
  })()
}

export const Req_GetTeamerAllList = function (data) {
  return newAxios({
    url:`/i/tenant/crm/customer/user/Lite`,
    data: {...data, pageSize: 200}
  })()
}

export const Req_UpdateTeamer = function (data) {
  return newAxios({
    url: '/updateTeamer',
    data
  })()
}

export const Req_GetCompanyInfo = function (data) {
  return newAxios({
    url: `/i/tenant/user/group/info/${data.groupId}`
  })()
}

export const Req_GetNoDepartPerson = function (data) {
  return newAxios({
    url: `/i/tenant/user/group/nodept`,
    data
  })()
}

export const Req_AppointTeamer = function (data) {
  return newAxios({
    url: `/i/tenant/system/dept/assign/for/user`,
    data: {...data}
  })()
}

export const Req_DepartAssignList = function (data) {
  return newAxios({
    url: `/i/tenant/system/dept/assign/list`,
    data
  })()
}

export const Req_GetTeamDeptInfo = function (data) {
  return newAxios({
    url:`/i/tenant/system/dept/info/${data.id}`,
    data
  })()
}

export const Req_GetTeamerDetailList = function (data) {
  return newAxios({
    url: `/i/tenant/user/group/detail/page`,
    data
  })()
}

export const Req_bindCommiss = function (data) {
  return newAxios({
    url: `/i/tenant/user/commissioner`,
    data
  })()
}


export const Req_GetOnlineTime = function (data) {
  return newAxios({
    url: `/i/tenant/user/online/time/check`,
    data
  })()
}

export const Req_GetDeptMembers = function (id){
  return newAxios({
    url:`/i/tenant/system/dept/get/members/${id}`
  })()
}

export const Req_DeleteDeptMembers = function(data) {
  return newAxios({
    url:`/i/tenant/system/dept/remove/members`,
    data
  },'json')()
}

//获取后台所有权限配置
export const Req_GetSysAllPermission = function(data) {
  return newAxios({
    url:`/i/tenant/user/group/post/get/all/sys/permission`,
    data
  })()
}

//获取职位列表
export const Req_GetPositionList = function(data) {
  return newAxios({
    url:`/i/tenant/user/group/position/list`,
    data
  })()
}

//新增职位
export const Req_PositionSubmit = function (data) {
  return newAxios({
    url:`${data.positionId ? '/i/tenant/user/group/position/update' : '/i/tenant/user/group/position/add'}`,
    data
  },'json')()
}

//删除职位
export const Req_DeletePosition = function (data) {
  return newAxios({
    url:'/i/tenant/user/group/position/delete',
    data
  })()
}

//配置员工到职位
export const Req_SetMembersToPosition = function(data){
  return newAxios({
    url:`/i/tenant/user/group/position/config/position`,
    data
  },'json')()
}

//获取岗位列表
export const Req_GetJobList = function (data) {
  return newAxios({
    url:`/i/tenant/user/group/post/list`,
    data
  })()
}

//删除岗位
export const Req_DeleteJobItem = function (data) {
  return newAxios({
    url:`/i/tenant/user/group/post/delete`,
    data
  })()
}

//提交岗位信息
export const Req_SubmitJob = function (data) {
  return newAxios({
    url:`${data.postId ? '/i/tenant/user/group/post/update' : '/i/tenant/user/group/post/add'}`,
    data
  },'json')()
}

//获取岗位关联关系
export const Req_GetJobHeader = function (data) {
  return newAxios({
    url:`/i/tenant/user/group/post/get/header`,
    data
  })()
}

//配置岗位关联关系
export const Req_SetJobHeader = function (data) {
  return newAxios({
    url:`/i/tenant/user/group/post/config/header`,
    data
  },'json')()
}

//获取角色列表
export const Req_GetRoleList = function (data) {
  return newAxios({
    url:`/i/tenant/user/group/role/list`,
    data
  })()
}

//删除角色
export const Req_DeleteRole = function (data) {
  return newAxios({
    url:`/i/tenant/user/group/role/delete`,
    data
  })()
}

//新增角色
export const Req_SubmitRole = function(data) {
  return newAxios({
    url:`${data.groupRoleId ? '/i/tenant/user/group/role/update' : '/i/tenant/user/group/role/add'}`,
    data
  },'json')()
}


//获取部门/小组的管理人
export const Req_GetHeadUser = function(data) {
  return newAxios({
    url:`/i/tenant/system/dept/get/department/head/user`,
    data
  })()
}

//获取没有部门的员工
export const Req_GetNoDeptUser = function(data) {
  return newAxios({
    url:`/i/tenant/system/dept/get/no/dept/user`,
    data
  })()
}

//获取部门列表（垂直）
export const Req_GetDeptVerticalList = function(data) {
  return newAxios({
    url:`/i/tenant/system/dept/vertical/list`,
    data
  })()
}

//提交部门/小组（新）
export const Req_SubmitDepartment = function(data) {
  return newAxios({
    url:`${data.id ? '/i/tenant/system/dept/edit/dept' : '/i/tenant/system/dept/add/dept'}`,
    data
  },'json')()
}

//获取员工详情
export const Req_GetUserInfo = function(data) {
  return newAxios({
    url:`/i/tenant/user/info`,
    data
  })()
}

//实时获取数据权限信息
export const Req_GetPermissionList = function(data){
  return newAxios({
    url:`/i/tenant/user/get/permission/list`,
    data
  },'json')()
}

//编辑员工
export const Req_EditUserInfo = function(data) {
  return newAxios({
    url:`/i/tenant/user/edit`,
    data
  },'json')()
}

//获取主管组长/部门经理人员
export const Req_GetPositionHeader = function(data) {
  return newAxios({
    url:`/i/tenant/user/group/position/get/header`,
    data
  })()
}

//配置主管组长/部门经理
export const Req_ConfigPositionHeader = function(data) {
  return newAxios({
    url:`/i/tenant/user/group/position/config/header`,
    data
  },'json')()
}

//机构列表
export const Req_GetGroup = function() {
  return newAxios({
    url:`/i/tenant/user/group/tree`
  })()
}

//新增服务单位
export const Req_AddServiceUnit = function(data) {
  return newAxios({
    url:`/i/tenant/user/group/service/unit/add`,
    data
  },'json')()
}

//修改服务单位
export const Req_UpdateServiceUnit = function(data) {
  return newAxios({
    url:`/i/tenant/user/group/service/unit/update`,
    data
  },'json')()
}

//删除服务单位
export const Req_DeleteServiceUnit = function(data) {
  return newAxios({
    url:`/i/tenant/user/group/service/unit/delete/${data.groupId}`,
  })()
}

//修改收款账户
export const Req_UpdatePayAccount = function(data) {
  return newAxios({
    url:`/i/tenant/crm/service/payment/account/update`,
    data
  },'json')()
}

//删除收款账户
export const Req_DeletePayAccount = function(data) {
  return newAxios({
    url:`/i/tenant/crm/service/payment/account/delete/${data.accountId}`
  })()
}

//根据权限获取员工列表
export const Req_GetPermissionStaffsList = function (data){
  return newAxios({
    url:`/i/tenant/user/permission/list/staffs`,
    data
  },'json')()
}


//获取未绑定用户的一级推介人手机
export const Req_GetRerrerPhone = function (data){
  return newAxios({
    url:`/i/tenant/crm/referrer/no/bind/level/one/get`,
    data
  })()
}
//添加机构专属客户账套
export const Req_AddGroupBook = function (data){
  return newAxios({
    url:`/i/tenant/crm/customer/group/add`,
    data
  },'json')()
}

//是否需要验证二级密码
export const Req_CheckNeedSecondary = function (data) {
  return newAxios({
    url:`/i/tenant/user/secondary/password/required`,
    data
  })()
}

//验证二级密码
export const Req_CheckSecondary = function (data) {
  return newAxios({
    url:`/i/tenant/user/secondary/password/validate`,
    data
  })()
}

//批量授权设置
export const Req_BatchLicence = function (data) {
  return newAxios({
    url:`/i/tenant/user/batch/licence`,
    data
  },'json')()
}

//重置二级密码
export const Req_ResetUserSecondaryPwd = function (data) {
  return newAxios({
    url:`/i/tenant/user/secondary/password/reset`,
    data
  })()
}

export const Req_GetProxyAccountList = () => {
  return newAxios({
    url: `/i/tenant/user/group/service/unit/proxy/tax/account`
  })()
}


// WEBPACK FOOTER //
// ./src/request/organize.js